import { Navigate, useParams } from "react-router-dom";

const SlotChangeRequestsListPage = () => {
  const { schoolId, trainingId } = useParams();

  return (
    <Navigate
      to={`/school/${schoolId}/admin/slot-change-requests/${trainingId}`}
      replace={true}
    />
  );
};

export default SlotChangeRequestsListPage;
